module.exports = __webpack_public_path__ + "img/icey-bottom.7d7e60db.png";